// extracted by mini-css-extract-plugin
export default {"button":"swishButton_button__wA6ap","slideIn":"swishButton_slideIn__oX7Wz"};